import * as cli from "./qcobjects-cli";
export default cli;